<template>
    <div>
        <div v-if="pending">
            <BaseSpinner />
        </div>
        <template v-else-if="!entry" /> <!-- empty case for when there is no entry, nuxt will show an error -->
        <article v-else>
            <HeroBasic
                :title="`${entry?.title} in ${route.params.year}`"
                :description="!route?.params?.year ? entry?.description : null"
            >
                <template #backlink>
                    <NuxtLink :to="t('toegewezen_bijdragen.backlink.uri')">
                        <div class="sr-only">{{ t('a11y.return-to') }}</div>
                        <BaseIcon icon="chevron-left" />
                        {{ t('toegewezen_bijdragen.backlink.label') }}
                    </NuxtLink>
                </template>
            </HeroBasic>

            <FlexibleSections
                v-if="entry?.flexibleSections"
                :sections="entry.flexibleSections"
            />

            <BaseSection>
                <ToegewezenBijdragenCollection :year="route.params.year" />
            </BaseSection>
        </article>
    </div>
</template>

<script setup>
import { formatISO } from 'date-fns';
import getPage from '~/graphql/queries/getPage.graphql';

definePageMeta({
    validate(route) {
        // Check if the year is made up of 4 digits
        return /^\d{4}$/.test(route.params.year);
    },
});

const { t } = useI18n();

const { variables: defaultVariables }  = useCraftGraphql();

const route = useRoute();

const variables = computed(() => {
    const now = formatISO(Date.now(), { representation: 'date' });

    return {
        ...defaultVariables,
        now: ['or', `>= ${now}`, null],
        uri: 'toegewezen-bijdragen'
    };
});

const response = await useAsyncQuery({
    query: getPage,
    variables
});

// using response.pending in template is not reactive???
const pending = computed(() => response?.pending.value);

const { craftEntry: entry } = useCraftPageEther(response);
const mainStore = useMainStore();
watchEffect(() => {
    mainStore.toggleNewsletterSubscribe(entry.value?.showNewsletterSubscribe ?? false);
});
</script>
